/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConnectNinjaOneRequest
 */
export interface ConnectNinjaOneRequest {
    /**
     * Authorization code from the NinjaOne OAuth redirect
     */
    code: string;
    /**
     * The redirect URI used in the authorize request
     */
    redirectUri: string;
}

/**
 * Check if a given object implements the ConnectNinjaOneRequest interface.
 */
export function instanceOfConnectNinjaOneRequest(value: object): value is ConnectNinjaOneRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('redirectUri' in value) || value['redirectUri'] === undefined) return false;
    return true;
}

export function ConnectNinjaOneRequestFromJSON(json: any): ConnectNinjaOneRequest {
    return ConnectNinjaOneRequestFromJSONTyped(json, false);
}

export function ConnectNinjaOneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectNinjaOneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'redirectUri': json['redirectUri'],
    };
}

export function ConnectNinjaOneRequestToJSON(json: any): ConnectNinjaOneRequest {
    return ConnectNinjaOneRequestToJSONTyped(json, false);
}

export function ConnectNinjaOneRequestToJSONTyped(value?: ConnectNinjaOneRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'redirectUri': value['redirectUri'],
    };
}

